import type {Cardinality, SimpleCardinality} from 'schemaDefinition/types';

export const getSimpleCardinality = (
  cardinality?: Cardinality,
): undefined | SimpleCardinality =>
  cardinality === '2' ? 'multiple' : cardinality;
